var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 1.58333C13.8653 1.58333 17.4167 5.13475 17.4167 9.5C17.4167 13.8653 13.8653 17.4167 9.5 17.4167C5.13475 17.4167 1.58333 13.8653 1.58333 9.5C1.58333 5.13475 5.13475 1.58333 9.5 1.58333ZM9.5 0C4.25363 0 0 4.25363 0 9.5C0 14.7464 4.25363 19 9.5 19C14.7464 19 19 14.7464 19 9.5C19 4.25363 14.7464 0 9.5 0ZM9.49921 4.55208C10.0455 4.55208 10.4896 4.99542 10.4896 5.54167C10.4896 6.08792 10.0455 6.53125 9.49921 6.53125C8.95296 6.53125 8.51042 6.08792 8.51042 5.54167C8.51042 4.99542 8.95296 4.55208 9.49921 4.55208ZM11.0833 14.25H7.91667V13.4583C8.29983 13.3166 8.70833 13.2992 8.70833 12.8765V9.34008C8.70833 8.91733 8.29983 8.85083 7.91667 8.70913V7.91746H10.2917V12.8773C10.2917 13.3008 10.701 13.319 11.0833 13.4591V14.25Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.b014a8892f80920b58e3072cfe54ab41.svg";
export { ForwardRef as ReactComponent };